import React, {useContext, useEffect, useState} from 'react'
import {graphql} from 'gatsby'
import {css} from '@emotion/react'
import styled from '@emotion/styled'
import useInView from 'react-cool-inview'
import { globalHistory as history } from '@reach/router'

// Components
import SEO from '../components/seo'
import Layout from '../components/layout'
import Container from '../components/container'
import Footer from '../components/footer'
import Project from '../components/project'

import Scroll from '../components/scroll'


import theme from '../utils/theme';
import {CommonTextStyles} from '../utils/styles'

// Context
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from '../context/globalContextProvider'





const Welcome = (props) =>  { 
  return ( 
    <h1>Welcome to GeeksforGeeks</h1> 
  ) 
} 



/*
 * Component
 */
const IndexPage = (props) => {

  const {
    setRef,
    setSection
  } = props.pageProps || props // props.pageProps is fed from router in index.js


  useEffect(() => {
    console.log('scorll')
    setSection(location.pathname)
  }, []);

  const sections = [
    {
      title: 'First',
      id: 'first'
    },
    {
      title: 'Second',
      id: 'second'
    },
    {
      title: 'Third',
      id: 'third'
    }
  ]


  return (
    <>
      <Welcome />

      <div style={{overflow: 'hidden' }}>
        {
          sections.map((section, index) => {
            return (
              <div
                key={section.id}
                ref={setRef(section.id)}
                css={css`
                  height: 100vh;
                  background-color: hotpink;
                  width: 100%;
                  padding: 1rem;

                  &:nth-of-type(odd) {
                    background-color: lightblue;
                  }
                `}
              >
                { section.title }
              </div>
            )
          })
        }
      </div>
    </>
  )
}

export default IndexPage



